<template>
  <div v-if="author" class="modal fade" :id="'editAuthor-' + author.authorID" tabindex="-1" role="dialog"  aria-hidden="true">
    <div v-if="show !== false" class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header">
          <h4 class="modal-title">Edit author information : {{author.lastName}} {{author.firstName}}</h4>
        </div>
        <form v-on:submit="save">

          <div class="modal-body">
            <h5> Authors personnel information</h5>
            <div class="row" style="margin-top: 15px">
              <div class="col-xs-12 col-md-6">
                <div class="form-group">
                  <label class="control-label required" for="lastName">Last Name</label>
                  <input v-model="lastName" type="text" id="lastName" class="form-control" required>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-group">
                  <label class="control-label required" for="firstName">First Name</label>
                  <input v-model="firstName" type="text" id="firstName" class="form-control" required>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="form-group">
                  <label class="control-label" for="email">Email</label>
                  <input v-model="email" type="email" id="email" class="form-control">
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-group">
                  <label class="control-label" for="phone">Phone</label>
                  <input v-model="phone" type="tel" id="phone" class="form-control">
                </div>
              </div>
            </div>

            <h5> Authors affiliations information</h5>

            <div class="row" style="margin-top: 15px">
              <div class="col-xs-12 col-md-6">
                <div class="form-group">
                  <label class="control-label" for="organisationName">Name</label>
                  <input v-model="organisationName" type="text" id="organisationName" class="form-control">
                </div>
              </div>
              <div class="col-xs-12 col-md-6" v-if="countries">
                <div class="form-group">
                  <label class="control-label" for="organisationCountry">Country</label>
                  <v-select2 id="organisationCountry" :options="countries" label="name" v-model="organisationCountry" :searchable="true" :dropdownParent="'editAuthor-' + author.authorID"></v-select2>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="form-group">
                  <label class="control-label" for="organisationCity">City</label>
                  <input v-model="organisationCity" type="text" id="organisationCity" class="form-control">
                </div>
              </div>
            </div>

            <div style="text-align: right;margin-top: 10px">
              <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save Changes</vue-ladda>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>

import vSelect2 from '../../components/utils/select2'
import VueLadda from 'vue-ladda'

export default {
  components: {
    VueLadda,
    vSelect2
  },
  props: ['value'],
  name: 'EditAuthor',
  watch: {
    author: function () {
      this.lastName = this.author.lastName
      this.firstName = this.author.firstName
      this.phone = this.author.phone
      this.email = this.author.email
      if (typeof this.author.affiliation !== 'undefined') {
        this.organisationName = this.author.affiliation.organisationName
        this.organisationCountry = this.author.affiliation.country
        this.organisationCity = this.author.affiliation.city
      }
    }
  },
  methods: {
    save: function (e) {
      e.preventDefault()

      this.submit.loading = true

      this.$requestStack.add('post', 'editData/author', {
        author_id: this.author.authorID,
        lastName_old: this.author.lastName,
        lastName_new: this.lastName,
        firstName_old: this.author.firstName,
        firstName_new: this.firstName,
        email_old: this.author.affiliation && typeof this.author.affiliation.email !== 'undefined'
          ? this.author.affiliation.email : null,
        email_new: this.email,
        phone_old: this.author.phone,
        phone_new: this.phone,
        organisationName_old: this.author.affiliation && typeof this.author.affiliation.organisationName !== 'undefined'
          ? this.author.affiliation.organisationName : null,
        organisationName_new: this.organisationName,
        organisationCity_old: this.author.affiliation && typeof this.author.affiliation.city !== 'undefined'
          ? this.author.affiliation.city : null,
        organisationCity_new: this.organisationCity,
        organisationCountry_old: this.author.affiliation && typeof this.author.affiliation.country !== 'undefined'
          ? this.author.affiliation.country : null,
        organisationCountry_new: this.organisationCountry !== null ? this.organisationCountry.name : null

      }, 0).then((response) => {
        if (this.$auth.check('basic') || this.$auth.check('seeker')) {
          this.$notify({
            type: 'info',
            title: 'Waiting validation',
            content: 'We will check information, and accept it soon',
            placement: 'bottom-right'
          })
        } else {
          let author = Object.assign({}, this.author)

          author.firstName = response.data.firstName
          author.lastName = response.data.lastName
          author.phone = response.data.phone
          author.affiliation = response.data.affiliation
          author.docs.forEach((document) => {
            document.co_authors.forEach((coAuthor) => {
              if (author.authorID === coAuthor.authorID) {
                coAuthor.firstName = author.firstName
                coAuthor.lastName = author.lastName
              }
            })
          })

          author.docs = Object.assign([], this.author.docs)

          this.$emit('input', author)
        }
        $('#editAuthor-' + this.author.authorID).modal('hide')
      }).catch((error) => {
      }).finally(() => {
        this.submit.loading = false
      })
    },
    getResources: function () {
      this.axios.get('/countries')
        .then((response) => {
          this.countries = response.data

          this.organisationCountry = this.countries.find((country) => {
            return country.name === this.author.affiliation.country
          })
        })
        .catch((error) => {
        })
    },
    openModal: function () {
      this.show = true

      setTimeout(() => {
        $('#editAuthor-' + this.author.authorID).modal('show')
      }, 200)

      $('#editAuthor-' + this.author.authorID).on('shown.bs.modal', () => {
        this.getResources()
      })

      $('#editAuthor-' + this.author.authorID).on('hide.bs.modal', () => {
        this.show = false
      })
    }
  },
  data () {
    return {
      show: false,
      author: null,
      lastName: null,
      firstName: null,
      email: null,
      phone: null,
      organisationName: null,
      organisationCountry: null,
      organisationCity: null,
      countries: [],
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  mounted () {
  },
  beforeMount () {
    this.author = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/EditAuthor.vue